// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"navLink-module--wrapper--39pj2","active":"navLink-module--active--1vzx1"};